/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { Header, RegistrationHeader } from '../components';

const HeaderContainer = ({ user, disable_click }) => {
  return user.is_logged_in
    ? <Header user={user} disable_click = {disable_click}/>
    : <RegistrationHeader />;
};

const mapStateToProps = (state) => ({ user: state.user });

const HeaderContainerConnected = connect(
  mapStateToProps
)(HeaderContainer);

export default HeaderContainerConnected;

